export default {
  language: 'Language', guest: 'Guest', login: 'Sign in',
  'section-game': 'THE GAME', 'section-tools': 'TOOLS OF WAR',
  'nav-home': 'Home', 'nav-rules': 'Game Rules',
  'nav-factions': 'Factions', 'nav-campaigns': 'Campaigns', 'nav-faqs': 'FAQs',
  'nav-army': 'Army Builder', 'nav-missions': 'Mission Cards',
  'nav-deployment': 'Deployment Maps',
  'footer-notice': 'Unofficial alternative web — not affiliated with StarCraft: The Tabletop Miniatures Game.',
  'footer-contact': 'Contact:', 'footer-version': 'Version',
};
